  import { VueLinkPopover } from 'vue-link-popover/dist/vue-link-popover'
  import { utcTimeZones } from 'mixins/time';
  import API from 'mixins/api';

  export default {
    props: ['payload'],
    mixins: [API, utcTimeZones],
    components: {
      'link-popover': VueLinkPopover
    },
    data() {
      return {
        commenters: []
      }
    },
    mounted() {
      // Get unique commenters
      this.commenters = _.uniq(_.map(this.payload.comments, function(comment) {
        return comment.commenter;
      }), function(commenter) {
        return commenter.name;
      });
    },
    methods: {
      toggleWatch() {
        if (this.isWatched) {
          this.api().unwatchDocument(this.payload.id, window.Spark.userId)
            .then(success => {
              if (success) {
                this.payload.watchers = _.filter(this.payload.watchers, (watcher) => {
                  return watcher.user_id !== window.Spark.userId;
                });
              }
            });
        } else {
          this.api().watchDocument(this.payload.id, window.Spark.userId)
            .then(result => {
              if (result) {
                this.payload.watchers.push(result);
              }
            });
        }
      },
      deletePayload() {
        Events.$emit('alertModal', {
          title: '',
          body: `Are you sure you want to delete ${this.payload.title}?`,
          actions: ['Yes', 'No'],
          done: (action) => {
            if (action === 'Yes') {
              this.api().deleteDocument(this.payload.id)
                .then(success => {
                  if (success) {
                    this.$emit('delete', this.payload);
                  }
                });
            }
          }
        });
      },
      limit: function(arr, start, limit) {
        let clone;
        if (Array.isArray(arr)) {
          clone = _.clone(arr);
          return clone.slice(start, limit)
        }

        return [];
      },
      copyDocument() {
        let newDoc = {
          'title': `${this.payload.title} (Copy)`,
          'copy_document_id': this.payload.id
        };

        this.api().createDocument(newDoc)
          .then(({id}) => {
            this.$router.push(`/a/document/${id}`);
          });
      }
    },
    computed: {
      isWatched() {
        return _.some(this.payload.watchers, (watcher) => {
          return watcher.user_id === window.Spark.userId;
        });
      }
    }
  }



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/document-lists.js